import { SET_ABSOLUTE_SESSION_TIMEOUT_FLAG } from '../actions/sessionTimeoutActions';
const initialState = {};
export default (state = initialState, action) => {
  //NOSONAR
  if (action.type === SET_ABSOLUTE_SESSION_TIMEOUT_FLAG) {
    return {
      ...state,
      absoluteSessionTimoutFlag: action.data,
    };
  }
  return state;
};
